/**
 * Base URL every service prefixes onto its request paths.
 *
 * Set REACT_APP_API_BASE_URL to an EMPTY string in production. That makes every request a
 * relative /api/... path, which is same-origin on whatever domain serves the app, so
 * vercel.json's rewrite proxies it to the backend and the browser never performs a CORS
 * check at all. It also means apex, www and preview deployments all work with no per-domain
 * allowlist to maintain.
 *
 * Note the `??` rather than `||`: an empty string is falsy, so `||` would silently fall back
 * to localhost in production and break every call. Only an *unset* variable should fall back.
 */
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:5287";

export const BASE_URL = API_BASE_URL.replace(/\/$/, "");

export default BASE_URL;
